// Simple in-memory cache for Firestore collection reads.
// Entries expire after TTL_MS. Call invalidate() after any write/update/delete
// so the next read gets fresh data.

const TTL_MS = 2 * 60 * 1000; // 2 minutes

const store = new Map();

const cache = {
  get(key) {
    const entry = store.get(key);
    if (!entry) return null;
    if (Date.now() - entry.ts > TTL_MS) {
      store.delete(key);
      return null;
    }
    return entry.data;
  },

  set(key, data) {
    store.set(key, { data, ts: Date.now() });
  },

  invalidate(key) {
    store.delete(key);
  },

  invalidatePrefix(prefix) {
    for (const key of store.keys()) {
      if (key.startsWith(prefix)) store.delete(key);
    }
  },
};

export default cache;
